export const getTcFBB = (language: string, isFiberPro: boolean) => {
	return {
		url: `myconnect/ebu_${language}/textContent/${isFiberPro ? 'TC_FIBER_PRO': 'TC_FBB'}`,
	};
};
